import { AppThemeNames } from "../themes/types"
import { CommonPagesDescriptions } from "./Common/types"
import { AuthTokenValidatorDescriptions } from "./components/AuthTokenValidator/types"
import { BreadcrumbDescriptions } from "./components/breadcrumb/types"
import { DashboardDescriptions } from "./components/Dashboard/types"
import { FooterDescriptions } from "./components/footer/types"
import { LoaderDescriptions } from "./components/Loader/types"
import { NavbarDescriptions } from "./components/navbar/types"
import { SearchableTableDescriptions } from "./components/searchableTable/types"
import { SidebarDescriptions } from "./components/Sidebar/types"
import { AccountPayablesPagesDescriptions } from "./Pages/AccountPayables/types"
import { ChatPagesDescriptions } from "./Pages/Chat/types"
import { ContractPaymentPagesDescriptions } from "./Pages/ContractPayment/types"
import { CustomerPagesDescriptions } from "./Pages/Customer/types"
import { PayableContractPagesDescriptions } from "./Pages/PayableContract/types"
import { QuotationPagesDescriptions } from "./Pages/Quotation/types"
import { SecurityPagesDescriptions } from "./Pages/security/types"
import { ServicePagesDescriptions } from "./Pages/Service/types"
import { ServiceContractPagesDescriptions } from "./Pages/ServiceContract/types"
import { SettingsPagesDescriptions } from "./Pages/Settings/types"
import { UserPagesDescriptions } from "./Pages/User/types"

export enum Languages {
    ENGLISH_US = 'en-us',
    SPANISH_US = 'es-us'
}

export const DefaultSettings = {
    SYSTEM_LANG: Languages.SPANISH_US,
    APP_THEME: process.env.REACT_APP_THEME || AppThemeNames.DEFAULT,
}

export interface Descriptions {
    PAGES: {
        ACCOUNT_PAYABLES: AccountPayablesPagesDescriptions
        CHAT: ChatPagesDescriptions
        COMMON: CommonPagesDescriptions
        CONTRACT_PAYMENT: ContractPaymentPagesDescriptions
        CUSTOMER: CustomerPagesDescriptions
        PAYABLE_CONTRACT: PayableContractPagesDescriptions
        SECURITY: SecurityPagesDescriptions
        SERVICE_CONTRACT: ServiceContractPagesDescriptions
        SERVICE: ServicePagesDescriptions
        SETTINGS: SettingsPagesDescriptions
        USER: UserPagesDescriptions
        QUOTATION: QuotationPagesDescriptions
    }
    COMPONENTS: {
        BREADCRUMB: BreadcrumbDescriptions
        DASHBOARD: DashboardDescriptions
        FOOTER: FooterDescriptions
        LOADER: LoaderDescriptions
        NAVBAR: NavbarDescriptions
        SEARCHABLE_TABLE: SearchableTableDescriptions
        SIDEBAR: SidebarDescriptions
        AUTH_TOKEN_VALIDATOR: AuthTokenValidatorDescriptions
    }
}

export interface FormItem {
    LABEL: string
    PLACEHOLDER: string
}

export interface ConfirmationModal {
    TITLE: string
    DESCRIPTION: string
    ACTION_BUTTON: string
    CANCEL_BUTTON: string
}

export interface SuccessModal {
    TITLE: string
    PRIMARY_LABEL: string
    SECONDARY_LABEL: string
    DESCRIPTION: string
}

export interface FormPageDescriptions {
    TITLE: string
    SAVE_BUTTON: string
    CANCEL_BUTTON: string
    CONFIRM_MODAL: ConfirmationModal
    CANCEL_MODAL: ConfirmationModal
    SUCCESS_MODAL: SuccessModal
    SUCCESS_SECONDARY_MODAL?: SuccessModal
    ERRORS?: {
        REQUIRED_FIELD: (fieldName: string) => string
        SAVE_ACTION: string
        UNKNOWN: string
    }
    MAIN_ACTION_TITLE: string
    MAIN_ACTION_DESCRIPTION: string
}

export interface ListPageDescriptions {
    TITLE: string
    TABLE: {
        ACTION_BUTTON: string
        SEARCH_PLACEHOLDER: string
        LOADING_DATA: string
    }
}
